<template>    
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">                  
                <div class="row mb-5">
                    <div class="col-lg-3">
                        <edit-user-side-nav :ubns="user?.ubNs || []" />
                    </div>
                    <div class="col-lg-9 mt-lg-0 mt-4">
                        <user-detail @user-loaded="user = $event" />                        
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>        
</template>

<script>
import EditUserSideNav from "./components/EditUserSideNav.vue"
import UserDetail from "./components/UserDetail.vue"

export default {
    name: 'User_edit_page',
    components: {
        EditUserSideNav,
        UserDetail
    },
    data() {
        return {
            Id: '',
            user: null,
            gets: []
        }
    },
    async mounted() {
        
    },
}
</script>